import { FormItemProps } from '@/components/Form/types'
import * as Yup from 'yup'


const Items: Array<FormItemProps> = [

	{
		name: 'id',
		type: 'Hidden',
	},

	{
		name: 'name',
		label: 'Name',
		type: 'Text',
		placeholder: 'Enter style name (e.g., Regular, Bold)',
		help: 'Name this specific style or weight, such as Regular, Medium, Bold, or Italic. The name appears under the font family.',
		validation: Yup.string().required('Style name is required'),
		classNames: {
			container: 'col-span-6 break-line',
			label: 'hidden',
		}
	},
	{
		name: 'file',
		label: 'Font File',
		type: 'File',
		help: 'Upload the file for this exact font style. Supported formats are TTF, OTF, WOFF, and WOFF2. Confirm the file matches the style name before adding it.',
		itemOptions: {
			acceptFormat: '.ttf, .otf, .woff, .woff2',
		},
		validation:Yup.object().typeError('Font is required'),
		classNames: {
			container: 'col-span-12 break-line',
			label: 'hidden',
		}
	}
]


export default Items;
